import { MultiStepFormState } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form-item';
import {
  MultiStepFormProvider,
  SubmitHandlerWithDirtyFields,
} from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { SetOrRemoveChargePointsLocationModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/inputs/set-or-remove-charge-points-location.model';
import { SubmitErrorHandler } from 'react-hook-form';

import { useUpdateChargePointLocationContext } from '../../charge-point.context';
import { ChargePointLocationUpdateFormStep1Controller } from '../charge-point-location-update-form-step-1/charge-point-location-update-form-step-1.controller';

export interface ChargePointLocationUpdateFormControllerProps {
  onError: SubmitErrorHandler<SetOrRemoveChargePointsLocationModel>;
  onSubmit: SubmitHandlerWithDirtyFields<SetOrRemoveChargePointsLocationModel>;
  onCancel: () => void;
  state: MultiStepFormState;
}

export const ChargePointLocationUpdateFormController = (
  props: ChargePointLocationUpdateFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel, state } = props;
  const data = useUpdateChargePointLocationContext();

  return (
    <MultiStepFormProvider<SetOrRemoveChargePointsLocationModel>
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      state={state}
      items={[
        {
          fields: ['locationId'],
          component: <ChargePointLocationUpdateFormStep1Controller />,
        },
      ]}
    />
  );
};
